<template>
  <section class="container release">  
    <div class="row">        
      <v-heading :level="1">Verbeteringen</v-heading>
    </div>
    <form @submit.prevent="validateBeforeSubmit">
      <div class="row">
        <div class="release__block col-xs-12">
          <div class="release__block__header">
            <h4>Recente verbeteringen</h4>
          </div>
          <legend v-html="releaseInfo.Content">
          </legend>
        </div>
      </div>
      <div class="row">
        <div class="release__block col-xs-12">
          <div class="release__block__header">
            <h4>Suggesties</h4>
          </div>
          <legend>
            Heb je suggesties voor dit platform? Vul dan het formulier hieronder in. Je kan kan er ook voor kiezen om het bericht anoniem te versturen. Klik hiervoor het vinkje aan onder het bericht.
          </legend>
          <div class="release__block__feedback">
            <v-textarea-group
                v-model="formData[formConfig.comments.ref]"
                @blur="validateField(formConfig.comments.ref, formData[formConfig.comments.ref])"
                :error="!!formErrors[formConfig.comments.ref]"
                :errorMessage="formErrors[formConfig.comments.ref]"
                :rule="formConfig.comments.rule"
                :label="formConfig.comments.label"
                :inputid="formConfig.comments.ref">
              </v-textarea-group>
          </div>
          <legend>
            <v-checkbox-group
              v-model="formData[formConfig.anonymousEnabled.ref]"
              @input="validateField(formConfig.anonymousEnabled.ref, formData[formConfig.anonymousEnabled.ref])"
              :initvalue="formConfig.anonymousEnabled.model"
              :error="!!formErrors[formConfig.anonymousEnabled.ref]"
              :errorMessage="formConfig.anonymousEnabled.errorMessage"
              :rule="formConfig.anonymousEnabled.rule"
              :label="formConfig.anonymousEnabled.label"
              :inputid="formConfig.anonymousEnabled.ref">
            </v-checkbox-group>
          </legend>
        </div>
      </div>
      <div class="row grid-justify-content-right">
        <div class="col-xs-2">
          <v-button md primary tagelement="button">VERSTUREN</v-button>
        </div>
      </div>
    </form>
  </section>
</template>
<script>
import store from '@/store'
import { mapGetters, mapActions } from 'vuex'
import { Validator } from 'vee-validate'
import VCheckboxGroup from '@/components/shared/form/CheckboxGroup'
import { EventBus } from '@/components/shared/event-bus.js'
import router from '@/router'

export default {
  name: 'v-releases',
  components: {
    VCheckboxGroup
  },
  data () {
    return {
      validator: new Validator(),
      formData: {
        AnonymousEnabled: false
      },
      formErrors: {
        Comments: undefined
      }
    }
  },
  computed: {
    ...mapGetters({
      releaseInfo: 'releases/getReleaseInfo'
    }),
    formConfig () {
      return {
        comments: {
          ref: 'Comments',
          label: 'Uw bericht:',
          attached: true,
          alias: 'Uw bericht:',
          rule: {
            required: true
          }
        },
        anonymousEnabled: {
          ref: 'AnonymousEnabled',
          alias: 'Anoniem insturen',
          label: 'Anoniem insturen',
          rule: {
            required: false
          },
          attached: true
        }
      }
    }
  },
  created () {
    store.dispatch('releases/fetchReleaseInfo')
    this.attachFieldsToValidator()
  },
  methods: {
    ...mapActions({submitedReleaseForm: 'releases/submitReleaseForm'}),
    attachFieldsToValidator () {
      for (let key in this.formConfig) {
        if (this.formConfig[key].attached) {
          this.validator.attach(
            this.formConfig[key].ref,
            this.formConfig[key].rule,
            { alias: this.formConfig[key].alias })
        }
      }
    },
    validateBeforeSubmit () {
      this.validateAllFields()
      this.setErrors()
    },
    validateAllFields () {
      const validateObj = {}
      for (let key in this.formConfig) {
        const config = this.formConfig[key]
        if (typeof config.ref !== 'undefined') {
          validateObj[config.ref] = this.formData[config.ref]
        }
      }
      this.validator.validateAll(validateObj).then(validated => {
        if (validated) {
          this.submitedReleaseForm(this.formData).then((response) => {
            if (response === true) {
              this.$emit('success')
              EventBus.$emit('alert', { message: 'Bedankt, uw suggestie is met succes verstuurd!' })
            } else {
              EventBus.$emit('alert', { message: 'Oops het versturen ging niet helemaal goed. Laten we dit als eerste maar eens verbeteren.' })
            }
            setTimeout(() => {
              router.push('/')
            }, 2000)
          })
        } else {
        }
      }).catch(() => {
      })
    },
    validateField (ref, model) {
      this.validator.validate(ref, model)
      this.setErrors()
    },
    setErrors () {
      // If the validator contains no errors
      if (this.validator.errors.items.length === 0) {
        for (let key in this.formConfig) {
          if (typeof this.formConfig[key].ref !== 'undefined') {
            this.formErrors[this.formConfig[key].ref] = undefined
          }
        }
      } else if (this.validator.errors.items.length > 0) {
        // If the validator contains errors
        const keysWithErrors = []
        const keysWithoutErrors = []

        // Loop through all the fields
        for (let key in this.formConfig) {
          let keyHasError = false
          let keyError = {}
          // Loop over all the errors
          this.validator.errors.items.forEach((error, index) => {
            // If the field has an error then assign that error to the field
            if (this.formConfig[key].ref === error.field) {
              keyHasError = true
              keyError = error
            }
            // If at the end of the loop then push it in the right array
            if (this.validator.errors.items.length - 1 === index) {
              if (keyHasError === true) {
                keysWithErrors.push({
                  key: key,
                  error: keyError
                })
              } else if (typeof this.formConfig[key].ref !== 'undefined') {
                keysWithoutErrors.push(key)
              }
            }
          })
        }
        // Keys without errors are set to no error
        keysWithoutErrors.forEach((key) => {
          this.formErrors[this.formConfig[key].ref] = undefined
        })
        // Keys with errors are set to there error message
        keysWithErrors.forEach((obj) => {
          this.formErrors[this.formConfig[obj.key].ref] = obj.error.msg
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .release {
    font-size: 16px;
    &__block {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
      background-color: $white;
      margin: 20px 0px 20px 0px;
      legend {
        padding: 15px 20px 15px 20px;
        color: $gray-darkest;
      }
      &__header {
        background-color: rgba(0, 0, 0, 0.03);
        h4 {
          color: $grayish-very-dark;
          font-size: 16px;
          font-weight: 400;
          padding: 0px 20px 0px 20px;
        }
      }
      &__feedback {
        padding: 0px 20px;
      }
    }
  } 
</style>
